<template>
  <GekkoButton
    @click="toggleArchived($event)"
    :text="archivedText"
    :icon="archivedIcon"
    variant="link"
    size="sm"
    class="p-0 text-info"
  />
</template>
<script>
import GekkoButton from "@/components/GekkoButton";
export default {
  name: "ArchiveBase",
  props: {
    data_object: Object,
  },
  components: { GekkoButton },
  data() {
    return {
      is_archived: "",
      item: {}
    }
  },
  computed: {
    archivedText() {
      return (this.is_archived) ? this.$gettext('Archived (undo)') : this.$gettext('Archive')
    },
    archivedIcon() {
      return (this.is_archived) ? 'fa-solid fa-rotate-left' : 'fa-solid fa-folder'
    }
  },
  created(){
    this.initialize();
  },
  methods: {
    initialize() {
      this.item = this.$props.data_object;
      this.is_archived = this.$props.data_object.archived || this.$props.data_object.is_archived;
    },
    toggleArchived(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.canArchive())
        this.extendable();
      else
        this.$store.commit('togglePremiumModal', 'web_trips_createcar');
    },
    extendable() {
      console.log("please override this function");
    },
    canArchive() {
      // override this method if a check is needed before archiving
      return true;
    },
    swapState() {
      this.is_archived = !this.is_archived;
      this.item.archived = this.is_archived;
      this.item.is_archived = this.is_archived;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>